import * as Turbo from "@hotwired/turbo"
import { format, isValid, parse } from 'date-fns'
import "./utils/jquery.js"
import "./utils/utility.js"
import "./utils/voice.js"
import "./utils/fireworks.js"
import "./utils/messaging.js"
import "./utils/health_manager.js"

import "alpine-turbo-drive-adapter"
import Alpine from "./src/alpine.js"

window.Alpine = Alpine
window.Turbo = Turbo

import "./src/ehop-trix.js"
import "./src/controllers/flash.js"
import "./src/controllers/workout.js"
import "./src/controllers/combobox.js"
import "./src/controllers/post_like.js"
import "./src/controllers/datepicker.js"
import "./src/controllers/turbo_form.js"
import "./src/controllers/tag_filter.js"
import "./src/controllers/line_chart.js"
import "./src/controllers/sign_in_link.js"
import "./src/controllers/private_notes.js"
import "./src/controllers/profile_photo.js"
import "./src/controllers/timed_exercise.js"
import "./src/controllers/cross_team_post.js"
import "./src/controllers/message_container.js"
import "./src/controllers/assessment_wizard.js"
import "./src/controllers/lesson_photo_upload.js"
import "./src/controllers/wheel_of_life_chart.js"
import "./src/controllers/appointment_calendar.js"
import "./src/controllers/client_private_notes.js"
import "./src/controllers/game_submission_form.js"
import "./src/controllers/availability_calendar.js"
import "./src/controllers/workout_exercise_form.js"
import "./src/controllers/incentive_photo_upload.js"
import "./src/controllers/post_comment_deletetion.js"
import "./src/controllers/assessment_screen_wizard.js"
import "./src/controllers/community_post_comment_form.js"

document.addEventListener('DOMContentLoaded', () => {
  Alpine.start()
})
